export const NO_TEAM_ID = '__UNASSIGNED_TEAM__';
export const CREATE_TEAM_ID = '__CREATE_TEAM__';
